import React from "react";
import logo from "./images/logo.png"; // Ensure this is a PNG with transparency

const Preloader = () => {
  return (
    <div className="preloader">
      <img src={logo} alt="Loading..." className="preloader-logo" />
    </div>
  );
};

export default Preloader;
